const modeRegisterEnum = Object.freeze({
  DEFAULT: 'default',
  TUTORIZE: 'tutorize',
});

export {
  modeRegisterEnum,
};
